import React from 'react';
import { SplashScreen } from './SplashScreen'
import { SupervisorDashboard } from './SupervisorDashboard'
import { useHasRight } from '../../Hooks/hasRight';
import { CAN_VIEW_MOBILE_DASHBOARD } from '../../utils/enums'
import { SOFTWARE_VERSION } from '../../utils/config';

export default () => {
  const canViewMobileDashboard = useHasRight(CAN_VIEW_MOBILE_DASHBOARD) || useHasRight('CAN_VIEW_SUPERVISOR_DASHBOARD')

  return <>
    {canViewMobileDashboard
      ? <SupervisorDashboard />
      : <SplashScreen />
    }
    <p style={{ textAlign: 'right' }}>Software Version: {SOFTWARE_VERSION}</p>
  </>
}
